// extracted by mini-css-extract-plugin
export var tocpicsGobackBtn = "bV_gd";
export var topicsFilterContainer = "bV_gb";
export var topicsFilterWrapper = "bV_gc";